"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrivalDays = void 0;
const merlin_chip_1 = require("@travelnest/merlin.chip");
const react_1 = __importDefault(require("react"));
const InlineMessage_1 = require("../../../../view/components/inline-message/InlineMessage");
const types_1 = require("../../../../types");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const helpers_1 = require("../../../../entities/pricing/helpers");
const fullStory_1 = require("../../../../util/fullStory");
const index_1 = require("../../../../index");
const ArrivalDays = ({ defaults, setDefaults, validation, showValidation, setShowValidation }) => {
    const selectedDays = (0, helpers_1.convertCheckinDaysArrayToDaysSelectionMap)(defaults.checkin_days);
    const setDay = (day, selected, currentSelectedDays) => {
        const nextSelectedDays = Object.assign(Object.assign({}, currentSelectedDays), { [day]: selected });
        setDefaults(Object.assign(Object.assign({}, defaults), { checkin_days: (0, helpers_1.convertDaysSelectionMapToCheckinDaysArray)(nextSelectedDays) }));
    };
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_checkin_days_modal_viewed', { property_id: propertyId });
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading_1.HeadingSmall, null, "Arrival days"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Paragraph_1.Paragraph, null, "On which days can guests arrive?"),
        react_1.default.createElement(Spacer_1.Spacer, null),
        Object.entries(types_1.DaysOfWeekFullNames).map(([dow, fullName]) => (react_1.default.createElement(merlin_chip_1.Chip, { id: dow, key: dow, text: fullName, selected: selectedDays[dow], onChange: (_, selected) => {
                setDay(dow, selected, selectedDays);
                setShowValidation(true);
            } }))),
        showValidation && !(validation === null || validation === void 0 ? void 0 : validation.checkin_days) &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Spacer_1.Spacer, null),
                react_1.default.createElement(InlineMessage_1.InlineError, { text: "Please select at least one day" })));
};
exports.ArrivalDays = ArrivalDays;
//# sourceMappingURL=ArrivalDays.js.map